<lib-renderer-container
  [params]="params"
  [tooltip]="names.join(', ')">
  &nbsp;
  <span class="display-value">{{ names.join(', ') }}</span>
  <mat-icon class="expand-icon" svgIcon="{{EsvgFiles.arrow_down}}" (click)="startEdit($event)"></mat-icon>
</lib-renderer-container>
